import { SUBSCRIPTION } from './types';

export const getSubscription = () => ({
  type: SUBSCRIPTION.GET_SUBSCRIPTION
})

export const getSubscriptionSuccess = (subscriptionList, notificationCount) => ({
  type: SUBSCRIPTION.GET_SUBSCRIPTION_SUCCESS,
  subscriptionList,
  notificationCount
})
export const removeNotifications = () => ({
  type: SUBSCRIPTION.GET_SUBSCRIPTION_VIEWED,
})

export const getSubscriptionFailure = (subscriptionError) => ({
  type: SUBSCRIPTION.GET_SUBSCRIPTION_FAILURE,
  subscriptionError
})

export const getSubscriptionInfo = () => ({
  type: SUBSCRIPTION.GET_SUBSCRIPTION_INFO,
})

export const getSubscriptionInfoSuccess = (subscriptionInfo) => (
  {
  type: SUBSCRIPTION.GET_SUBSCRIPTION_INFO_SUCCESS,
  subscriptionInfo
})

export const setSubscriptionExpiredStatus = ( c2c, adhoc, isSingleSubs) => (
  {
  type: SUBSCRIPTION.SET_EXPIRED_STATUS,
  c2c, adhoc, isSingleSubs
})
//a: isEducationAvailable, b: isCollaborationAvailable, adhoc: isAdhocAvailable, c: entRoles, d: homePath, activeConfigList: Object having info whether edu,collab and adhoc is active
export const setUserDetails = (b, adhoc, activeConfigList, c, d) => (
  {
  type: SUBSCRIPTION.SET_USER_DETAILS,
    b, adhoc, activeConfigList, c, d
})

export const forbiddenAccessAction = () => ({
  type: SUBSCRIPTION.FORBIDDEN_ACCESS
})

export const noActiveSubsAction = () => ({
  type: SUBSCRIPTION.NO_ACTIVE_SUBS
})